module.exports = __webpack_public_path__ + "static/media/02. Sekolah.mu.956ffad2.png";